export const getObjectDiff = <T>(a: T, b: T): Partial<T> => {
  const result: Partial<T> = {}
  for (const key in a) {
    if (a[key] !== b[key]) {
      result[key] = a[key]
    }
  }
  return result
}
